import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { sanitizeCommunicationChannel } from "@shared/helpers/communication-channel";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Association } from "../association";
import { type CommunicationRecord } from "./entity";
import { Group } from "../group";
import { Opportunity } from "../opportunity";

const organizationManagersCommsWhere = () => ({
  $or: [
    {
      association: {
        $is: {
          organizationId: remult.user!.organizationId,
        },
      },
    },
    {
      group: {
        $is: {
          organizationId: remult.user!.organizationId,
        },
      },
    },
    {
      opportunity: {
        $is: {
          organizationId: remult.user!.organizationId,
        },
      },
    },
    {
      summerCampaignLeadId: { $ne: null as unknown as string },
    },
    {
      partnerOrganizationId: { $ne: null as unknown as string },
    },
    {
      volunteerOrganizationId: { $ne: null as unknown as string },
    },
  ],
});

export const CommunicationRecordEntityConfig: HyperEntityConfig<CommunicationRecord> =
{
  allowApiRead: Allow.authenticated,
  allowApiCrud: Roles.AdminsAndManager,
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.AdminsAndManager, organizationManagersCommsWhere());

    filter(Roles.User, false);
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, (entity) =>
      !!entity.associationId &&
      doesExist(Association, {
        id: entity.associationId,
        organizationId: remult.user!.organizationId!,
      }),
    );
    allow(Roles.OrganizationManagers, (entity) =>
      !!entity.groupId &&
      doesExist(Group, {
        id: entity.groupId,
        organizationId: remult.user!.organizationId!,
      }),
    );
    allow(Roles.OrganizationManagers, (entity) =>
      !!entity.opportunityId &&
      doesExist(Opportunity, {
        id: entity.opportunityId,
        organizationId: remult.user!.organizationId!,
      }),
    );
    allow(Roles.OrganizationManagers, (entity) => !!entity.summerCampaignLeadId);
    allow(Roles.AdminsAndManager, (entity) => !!entity.partnerOrganizationId);
    allow(Roles.AdminsAndManager, (entity) => !!entity.volunteerOrganizationId);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.AdminsAndManager, organizationManagersCommsWhere());
  },

  saving(entity) {
    entity.channel = sanitizeCommunicationChannel(entity.channel);
  },
};
